module.exports = __webpack_public_path__ + "static/blue_fast_fact-9268f420ce7bbad407836ac948411a74.svg";